const howdenGroupMicrosoftEntraDevConfig = {
  msalConfig: {
    auth: {
      clientId: '5c90511f-bd41-45cd-9287-7e9f4cea332c',
      authority: 'https://login.microsoftonline.com/organizations',
      redirectUri: () => `${location.origin}/granted`,
      postLogoutRedirectUri: () => `${location.origin}/logout`
    }
  },
  apiConfig: {
    clientId: '93360c27-fe5a-4510-a638-1d7cf3a1e97a',
    scopes: ['api://93360c27-fe5a-4510-a638-1d7cf3a1e97a/user_impersonations']
  },
  protectedResources: new Map([
    ['https://graph.microsoft.com/v1.0/me', ['user.read']],
    [`${location.origin}`, ['api:// 93360c27-fe5a-4510-a638-1d7cf3a1e97a/user_impersonations']]
  ])
};

export { howdenGroupMicrosoftEntraDevConfig };
